import { createSlice } from "@reduxjs/toolkit";

export const registryTimeSlice = createSlice({
  name: "registryTime",
  initialState: {
    timeCount: 0,
  },
  reducers: {
    addTime: (state, action) => {
      state.timeCount += action.payload;
    },
    resetTime: (state) => {
      state.timeCount = 0;
    },
  },
});

export const { addTime, resetTime } = registryTimeSlice.actions;

export default registryTimeSlice.reducer;
